export type Configs = {
  API_URL: string;
  USE_MOCK_API: boolean;
};

const configs: Configs = {
  API_URL: process.env.REACT_APP_API_URL ?? '',
  USE_MOCK_API: process.env.REACT_APP_USE_MOCK_API === 'true',
};
export default configs;
